<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import RouterLinkImmediate from '@/components/navigation/RouterLinkImmediate.vue';
import { useI18n } from '@/i18n/index.ts';
import { PRODUCT_NAME } from '@/utils/brand.ts';

type Props = {
  size?: 'small' | 'medium' | 'large';
  to?: RouteLocationRaw;
};

const props = withDefaults(defineProps<Props>(), { size: 'medium' });
const { t } = useI18n();

const sizeClasses = computed(
  () =>
    ({
      small: 'gap-1 text-sm',
      medium: 'gap-2 text-xl',
      large: 'gap-3 text-3xl',
    })[props.size],
);
const imageClasses = computed(
  () =>
    ({
      small: 'h-5 w-5',
      medium: 'h-8 w-8',
      large: 'h-14 w-14',
    })[props.size],
);
</script>

<template>
  <RouterLinkImmediate
    v-if="to"
    :to
    :aria-label="t('brand.homeLink')"
    class="text-base-content focus-visible:outline-primary rounded-field font-display inline-flex min-w-0 items-center no-underline focus-visible:outline-2 focus-visible:outline-offset-2"
    :class="sizeClasses"
  >
    <img
      src="/vennevent-logo-1.png"
      alt=""
      aria-hidden="true"
      class="shrink-0 object-contain"
      :class="imageClasses"
    />
    <span>{{ PRODUCT_NAME }}</span>
  </RouterLinkImmediate>
  <span
    v-else
    class="text-base-content font-display inline-flex min-w-0 items-center"
    :class="sizeClasses"
  >
    <img
      src="/vennevent-logo-1.png"
      alt=""
      aria-hidden="true"
      class="shrink-0 object-contain"
      :class="imageClasses"
    />
    <span>{{ PRODUCT_NAME }}</span>
  </span>
</template>
